module.exports = __webpack_public_path__ + "static/media/pratic-logo.cdae1260.svg";